<template>
  <div class="block-container" v-if="!loading">
    <div class="block-title">
      <div>今日推荐</div>
      <!-- <div>
        <van-icon name="arrow"
          @click="showMoreEpisodes"
        />
      </div> -->
    </div>
    <div v-if="config.direction == 'vertical'">
      <episode-list
        v-if="episodeIds.length > 0"
        :slug="slug"
        :episode-ids="episodeIds"
        :show-no-more-hint="false"
      />
      <div class="btn">
        <van-button
          size="small"
          icon="notes-o"
          color="#f5f6f7"
          @click="showMoreEpisodes"
        >查看更多</van-button>
      </div>
    </div>
    <div v-if="config.direction == 'horizontal'">
      <div class="outer-container">
        <div class="inner-container">
          <!-- <episode-card-v2
            v-for="(item, idx) in items"
            :key="item.id"
            :episode="item"
            :class="idx>0 ? 'item left-margin': 'item first'"
          /> -->
          <episode-card-v2
            v-for="(episodeId, idx) in episodeIds"
            :key="episodeId"
            :episode-id="episodeId"
            :class="idx>0 ? 'item left-margin': 'item first'"
          />
          <div class="item left-margin show-more">
            <van-button
              type="default"
              size="normal"
              icon="notes-o"
              color="#f5f6f7"
              @click="showMoreEpisodes"
            >查看更多</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EpisodeList from '../../episode-list.vue'
  import EpisodeCardV2 from '../episode-card-v2.vue'
  import { Swipe, SwipeItem } from 'vant'
  import Vue from 'vue'
  Vue.use(Swipe, SwipeItem)

  export default {
    name: "BlockTodayRecommends",
    components: {
      EpisodeCardV2,
      EpisodeList
    },
    data () {
      return {
        loading: true,
        slug: '', // show 的 slug
        items: [], // 未隐藏的条目列表
        config: {}, // 设置
        swipeShow: true,
        swipeStyle: {
          height: '157px',
          borderRadius: '4px'
        },
        episodeIds: []
      }
    },
    methods: {
      getConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.todayRecommendsConfig.list(params).then(res => {
          if (res.data.count > 0) {
            if (res.data.results[0].enable) {
              window.console.log("今日推荐区块已启用")
              that.getTodayRecommends()
              that.config = res.data.results[0]
            } else {
              window.console.log("今日推荐区块已禁用")
            }
          } else {
            window.console.log("未找到相关配置")
          }
        })
      },
      getTodayRecommends: function () {
        // 获取今日推荐
        let that = this
        let params = {
          slug: that.slug,
          // hidden: false,
          limit: 5,
          // offset: 6
        }
        // that.$api.episode.list(params).then(res => {
        //   window.console.log("获取到今日推荐")
        //   window.console.log(res)
        //   that.items = res.data.results
        //   let episodeIds = []
        //   for (let i = 0; i < res.data.results.length; i++) {
        //     const e = res.data.results[i]
        //     episodeIds.push(e.id)
        //   }
        //   that.episodeIds = episodeIds
        // })
        that.$api.todayRecommend.list(params).then(res => {
          window.console.log("获取到今日推荐")
          window.console.log(res)
          // that.items = res.data.results
          if (res.data.results.length > 0) {
            let episodeIds = []
            for (let i = 0; i < res.data.results[0].items.length; i++) {
              const episodeId = res.data.results[0].items[i].objectId
              episodeIds.push(episodeId)
            }
            that.episodeIds = episodeIds
            window.console.log("taht.episodeIds:", that.episodeIds)
          }
        })
      },
      imageOnLoad: function (e) {
        // window.console.log("imageOnLoad:", e)
        let swipeStyle = this.swipeStyle
        swipeStyle.height = e.imageHeight
        this.swipeStyle = swipeStyle
      },
      swipeChange: function (e) {
        if (e == 0) {
          this.$refs.swipe.resize()
        }
      },
      clickItem: function (episodeId) {
        window.console.log("clickItem:", episodeId)
        this.$router.replace({
          name: 'EpisodeDetail',
          params: {
            episodeId: episodeId
          }
        })
      },
      showMoreEpisodes: function () {
        this.$router.replace({
          name: 'EpisodesAll',
          params: {}
        })
      },
    },
    watch: {
      // 横向跑马灯 topic 有一个 bug
      // 切到别的页面再切回来就会不显示
      // 这里监听切换状态，再重新显示此区块可规避此 bug
      // $route(to, from){
      //   if (from != to && from.name == 'Discovery') {
      //     this.swipeShow = false
      //   }
      //   if (to != from && to.name == 'Discovery') {
      //     this.swipeShow = true
      //   }
      // }
      'items': function (items) {
        if (items.length > 0) {
          this.loading = false
        }
      },
      'episodeIds': function (episodeIds) {
        if (episodeIds.length > 0) {
          this.loading = false
        }
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
      this.getConfig()
      // window.console.log("组件被加载")
    },
    destroyed () {
      // window.console.log("组件被销毁")
    }
  }
</script>

<style lang="css" scoped>
.block-title {
  background: #fff;
  padding: 10px 16px 0px 16px;
  color: #228df6;
  font-weight: bold;
  /* margin-bottom: 5px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.outer-container {
  width: 100%;
  overflow: scroll;
  background: #fff;
  padding: 10px 0px 16px 0px;
}
.inner-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.item {
  flex-shrink: 0;
  width: 32vw;
}
.left-margin {
  margin-left: 4vw;
}
.first {
  margin-left: 16px;
}
.block-container {
  border-top: 1px solid #ebedf0;
  border-bottom: 1px solid #ebedf0;
}
.btn {
  text-align: center;
  background: #fff;
  padding: 12px;
}
button.van-button div {
  color: #bcbdc0;
  font-weight: bold;
}
</style>
